// @NOTE: assumes jQuery is included by WP
const $ = jQuery

class header {
  constructor () {
    this.$window = $(window)
    this.$document            = $(document)
    this.$body                = $('body')
    this.$mobileNavButton     = $(".mobile-btn") 
    this.$closeMobileButton   = $(".close-mobile-nav")
    this.$mobileNavBg         = $(".mobile-nav-bg-curtain")
    this.$siteHeader          = $(".header-primary")
    this.mainNavDropdownArrow = '.main-nav-dropdown-arrow'    
    this.menuItemHasChildren  = '.menu-item-has-children'
    this.$menuItemHasChildren = $('.menu-item-has-children');

    this.addArrowToMainMobileNav()

    $(".nav-bar .navigation ul li a").click(function() {
      var header_height = $('.header-primary').outerHeight();
      $('html, body').animate({
        scrollTop: $( $.attr(this, 'href') ).offset().top - header_height
      }, 800);
      $(".navigation").removeClass('menu-open');
      $(".mobile-nav-bg-curtain").removeClass('menu-open');
      return false;
    });

    this.$mobileNavButton.click(function () { 
      $(".navigation").addClass('menu-open')
      $(".mobile-nav-bg-curtain").addClass('menu-open')
    }); 

    this.$closeMobileButton.click(function () { 
      $(".navigation").removeClass('menu-open') 
      $(".mobile-nav-bg-curtain").removeClass('menu-open')
    }); 

    this.$mobileNavBg.click(function () { 
      $(".navigation").removeClass('menu-open') 
      $(".mobile-nav-bg-curtain").removeClass('menu-open')
    });

    this.$document.on('click', this.mainNavDropdownArrow, (event) => {
      event.preventDefault()  
      const $currentTarget = $(event.currentTarget)  
      this.openSubMenuMobile($currentTarget)   
    })
  }

  openSubMenuMobile($currentTarget) {
    $currentTarget.parents(this.menuItemHasChildren).toggleClass('active') 
    $currentTarget.parents(this.menuItemHasChildren).find('.sub-menu').toggleClass('display')    
  }

  addArrowToMainMobileNav () {
    $('.main-nav-dropdown-arrow').remove()
    const svgArrow = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><g clip-path="url(#clip0_649_28)"><path d="M1.33334 5.73804L8.00001 11.9285L14.6667 5.73804" stroke="#B5CE2F" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/></g><defs><clipPath id="clip0_649_28"><rect width="16" height="14.8571" fill="white" transform="translate(0 0.785645)"/></clipPath></defs></svg>'
    $('.navigation').find('.menu-item-has-children > a').append('<span class="main-nav-dropdown-arrow">'+svgArrow+'</span>')
  }
  
  onWindowScroll (scrollTop) {
    if (scrollTop >= 10) {
      this.$siteHeader.addClass('js-fixed-header')
    } else {
      this.$siteHeader.removeClass('js-fixed-header')
    }
  }
}

export default header


// WEBPACK FOOTER //
// ./src/js/custom/header/header.js